import React from "react";
import { formatDistanceToNow } from 'date-fns';

/**
 * PostPreview — lightweight preview of a post for the share modal.
 * Renders only the header and content without heavy hooks
 * (IntersectionObserver, lazy loading, edit mode, solutions, comments, etc.).
 */
const PostPreview = ({
  username,
  profession,
  timestamp,
  avatar,
  content,
  title,
  imageUrl,
  imageUrls = [],
  type,
  sharedPostData,
  sharedPostId,
}) => {
  const isReshare = type === 'shared_post' && sharedPostData;

  const formatTimestamp = (ts) => {
    if (!ts) return '';
    if (typeof ts === 'object' && ts.toDate && typeof ts.toDate === 'function') {
      try { return formatDistanceToNow(ts.toDate(), { addSuffix: true }); } catch { return ''; }
    }
    const d = new Date(ts);
    if (isNaN(d.getTime())) return '';
    try { return formatDistanceToNow(d, { addSuffix: true }); } catch { return ''; }
  };

  const renderContent = () => (
    <div className="post__content">
      {title && <h3 className="post__title">{title}</h3>}
      {content && <p className="post__text">{content}</p>}
      {imageUrl && (
        <img
          src={imageUrl}
          alt={title || 'Post image'}
          className="post__image"
          loading="lazy"
        />
      )}
      {imageUrls && imageUrls.length > 0 && (
        <div className="post__image-grid">
          {imageUrls.slice(0, 4).map((url, i) => (
            <img
              key={i}
              src={url}
              alt={title ? `${title} (${i + 1})` : `Post image ${i + 1}`}
              className="post__image--grid"
              loading="lazy"
            />
          ))}
        </div>
      )}
    </div>
  );

  return (
    <div className="post is-inside-reshare">
      <div className="post__header">
        <div className="post__header-left">
          <div className="post__avatar">
            {avatar ? (
              <img src={avatar} alt={username} className="post__avatar-img" />
            ) : (
              <div className="post__avatar-placeholder">
                {(username || "U").charAt(0).toUpperCase()}
              </div>
            )}
          </div>
          <div className="post__meta">
            <span className="post__username">{username}</span>
            {profession && <span className="post__profession">{profession}</span>}
            {timestamp && <span className="post__timestamp"> • {formatTimestamp(timestamp)}</span>}
          </div>
        </div>
      </div>

      {renderContent()}

      {isReshare && (
        <div className="post__reshare">
          <PostPreview
            username={sharedPostData?.username}
            profession={sharedPostData?.userProfession}
            timestamp={sharedPostData?.timestamp}
            avatar={sharedPostData?.userPhotoURL}
            content={sharedPostData?.content}
            title={sharedPostData?.title}
            imageUrl={sharedPostData?.imageUrl}
            imageUrls={sharedPostData?.imageUrls}
            type={sharedPostData?.type}
            sharedPostData={sharedPostData?.sharedPostData}
            sharedPostId={sharedPostData?.sharedPostId}
          />
        </div>
      )}
    </div>
  );
};

export default PostPreview;
